import React from 'react';
import { Card, Skeleton } from '@mui/material';
// import WeekendIcon from '@mui/icons-material/Weekend';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// const formatDuration = (minutes) => {
//   if (minutes >= 60) {
//     return {
//       value: (minutes / 60).toFixed(2),
//       unit: 'hr Avg.'
//     };
//   }
//   return {
//     value: Number(minutes).toFixed(2),
//     unit: 'min Avg.'
//   };
// };

const StatItem = ({ label, counts, loading }) => {
  return (
    <div className="bg-white rounded p-3 mb-2">
      {loading ? (
        <>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </>
      ) : (
        <div className="flex flex-col">
          <div className="flex items-baseline gap-1">
            <span className="text-xl font-medium">{counts}</span>
          </div>
          <div className="text-sm text-gray-500">{label}</div>
        </div>
      )}
    </div>
  );
};

// const BreakItem = ({ breakNumber, count, dwellTime, loading }) => {
//   const formatted = formatDuration(dwellTime);
//   return (
//     <div className="bg-white rounded p-2 mb-2 text-sm shadow-sm">
//       {loading ? (
//         <>
//           <Skeleton variant="text" width="60%" height={24} />
//           <Skeleton variant="text" width="40%" height={20} />
//           <Skeleton variant="text" width="30%" height={20} />
//         </>
//       ) : (
//         <div className="flex items-start gap-2">
//           <FiberManualRecordIcon
//             sx={{
//               color: dwellTime > 2 ? '#ef4444' : '#22c55e',
//               fontSize: '12px',
//               marginTop: '4px'
//             }}
//           />
//           <div>
//             <div className="font-bold">Break {breakNumber}</div>
//             <div className="text-xs text-gray-500">Count: {count} people</div>
//             <div className="text-xs text-gray-500">
//               Duration: {formatted.value} {formatted.unit}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

const RestAreaCard = ({ data, loading }) => {
  // const averageDwellTime = data?.[0]?.average_dwell_time || 0;
  // const totalCount = data?.[0]?.total_count || 0;
  // const breaks = data?.[0]?.labels || [];
  // const formattedDwellTime = formatDuration(averageDwellTime);
  const idleTimeDate = data?.idleManPower[0];
  console.log('idleTimeDate', idleTimeDate);

  return (
    <div>
      <Card
        className="border relative border-gray-300"
        sx={{
          height: '276px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <div className="flex w-full flex-col gap-1 p-3">
          <div className="flex items-center gap-2">
            <AccessTimeIcon className="text-white rounded-full p-2 text-6xl" style={{ backgroundColor: '#ffa000' }} />
            <div style={{ width: loading ? '120px' : 'auto' }}>
              {loading ? (
                <>
                  <Skeleton variant="text" width="100%" height={40} />
                  <Skeleton variant="text" width="80%" height={28} />
                </>
              ) : (
                <>
                  <div className="flex items-baseline gap-1">
                    {/* <div>
                      <span className="text-3xl font-medium">{formattedDwellTime.value}</span>
                      <span className="text-sm text-gray-500 ml-1">{formattedDwellTime.unit}</span>
                    </div> */}
                    {/* <div className="border-l pl-1">
                      <span className="text-xl font-medium">{totalCount}</span>
                      <span className="text-sm text-gray-500 ml-1">visits</span>
                    </div> */}
                  </div>
                  <p className="text-lg font-semibold">Truck Count</p>
                </>
              )}
            </div>
          </div>
          <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
            <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>
            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">
                    {idleTimeDate?.total_entry_trucks ? idleTimeDate?.total_entry_trucks : 0}
                  </span>
                  <br />
                  <span className="text-sm text-gray-500">Entry</span>
                </>
              }
            />
            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">
                    {idleTimeDate?.total_exit_trucks ? idleTimeDate?.total_exit_trucks : 0}
                  </span>
                  <br />
                  <span className="text-sm text-gray-500">Exit</span>
                </>
              }
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RestAreaCard;
